import type { WorkflowProps } from 'flow/store/engine/types';
import getLocalSnippetVersion from './getLocalSnippetVersion';
import type { API } from '~/helpers/api-new/modules';


interface GetRemoteCurrentAndNextLocalSnippetOpts {
  snippetToken: string;
  typhonDomain: string;
  currentVersion: number;
  nextVersion: number;
  workflowProps: WorkflowProps;
  libraryApi: API['library'];
}

export default async function getRemoteCurrentAndNextLocalSnippets({
  currentVersion,
  libraryApi,
  nextVersion,
  snippetToken,
  typhonDomain,
  workflowProps,
}: GetRemoteCurrentAndNextLocalSnippetOpts) {
  const [
    remoteCurrentSnippet,
    remoteNextSnippet,
  ] = await Promise.all([
    getLocalSnippetVersion({
      libraryApi,
      snippetToken,
      typhonDomain,
      versionId: currentVersion,
      workflowProps,
      preservePublicIds: true,
    }),
    getLocalSnippetVersion({
      libraryApi,
      snippetToken,
      typhonDomain,
      versionId: nextVersion,
      workflowProps,
      preservePublicIds: true,
    }),
  ]);

  return {
    remoteCurrentSnippet,
    remoteNextSnippet,
  };
}
